import * as types from './actionTypes'

const INITIAL_STATE = JSON.parse(JSON.stringify({
  especialidadesAll: {
    isLoading: false,
    data: {
      rows: [],
      count: 0,
      page: 1,
      limit: 5,
    },
    receivedAt: null,
  },
  especialidades: {
    isLoading: false,
    data: [],
    receivedAt: null,
  },
  enderecos: {
    isLoading: false,
    data: [],
    receivedAt: null,
  },
  search: {
    isLoading: false,
    tipo: 'teleconsulta',
    data: {
      rows: [],
      count: 0,
      page: 1,
      limit: 5,
    },
    error: null,
    receivedAt: null,
  },
  medico: {
    isLoading: false,
    data: null,
    error: null,
    receivedAt: null,
  },
  medicoCalendar: {
    isLoading: false,
    data: null,
    error: null,
    receivedAt: null,
  },
  medicoRatings: {
    isLoading: false,
    data: {
      rows: [],
      avaliacao: {}
    },
    error: null,
    receivedAt: null,
  },
  rating: {
    isLoading: false,
    data: null,
    receivedAt: null,
  },
  saveRating: {
    isLoading: false,
    error: null,
  },
  plantao: {
    isLoading: false,
    data: null,
    error: null,
    receivedAt: null,
  },
  plantaoFila: {
    isLoading: false,
    data: null,
    error: null,
    receivedAt: null,
  },
  plantaoUnicoPrice: {
    isLoading: false,
    data: null,
    receivedAt: null,
  },
  savePlantaoUnico: {
    isLoading: false,
    error: null,
  },
  createAtendimento: {
    isLoading: false,
    error: null,
  },
  joinQueue: {
    isLoading: false,
    error: null,
  },
  leaveQueue: {
    isLoading: false,
    error: null,
  },
  atendimento: {
    isLoading: false,
    data: null,
    error: null,
    receivedAt: null,
  },
  scheduleCancel: {
    isLoading: false,
    error: null,
    success: null,
  },
  reschedule: {
    isLoading: false,
    error: null,
    success: null,
  },
  scheduleReturn: {
    isLoading: false,
    error: null,
    success: null,
  },
  medialRecords: {
    isLoading: false,
    data: null,
    error: null,
    receivedAt: null,
  },
  invoiceRequest: {
    isLoading: false,
  },
  confirmPresence: {
    isLoading: false,
  },
  cabins: {
    isLoading: false,
    data: {
      rows: [],
      count: 0,
      page: 1,
      limit: 5,
    },
    error: null,
    receivedAt: null,
  },
  cabin: {
    isLoading: false,
    data: null,
    error: null,
    receivedAt: null,
  },
}))

export default (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case types.REQUEST_ESPECIALIDADES_ALL:
    case types.RECEIVE_ESPECIALIDADES_ALL:
      return {
        ...state,
        especialidadesAll: {
          isLoading: action.isLoading,
          data: (action.data) ? action.data : state.especialidadesAll.data,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.REQUEST_ESPECIALIDADES:
    case types.RECEIVE_ESPECIALIDADES:
      return {
        ...state,
        especialidades: {
          isLoading: action.isLoading,
          data: (action.data) ? action.data : state.especialidades.data,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.REQUEST_ENDERECOS:
    case types.RECEIVE_ENDERECOS:
      return {
        ...state,
        enderecos: {
          isLoading: action.isLoading,
          data: (action.data) ? action.data : state.enderecos.data,
          receivedAt: action.receivedAt,
        }
      }
    case types.REQUEST_SEARCH:
    case types.RECEIVE_SEARCH:
      return {
        ...state,
        search: {
          isLoading: action.isLoading,
          tipo: (action.tipo) ? action.tipo : state.search.tipo,
          data: (action.data) ? action.data : state.search.data,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.REQUEST_MEDICO:
    case types.RECEIVE_MEDICO:
      return {
        ...state,
        medico: {
          isLoading: action.isLoading,
          data: (action.data) ? action.data : state.medico.data,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.REQUEST_MEDICO_CALENDAR:
    case types.RECEIVE_MEDICO_CALENDAR:
      return {
        ...state,
        medicoCalendar: {
          isLoading: action.isLoading,
          data: (action.data) ? action.data : state.medicoCalendar.data,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.REQUEST_MEDICO_RATINGS:
    case types.RECEIVE_MEDICO_RATINGS:
      return {
        ...state,
        medicoRatings: {
          isLoading: action.isLoading,
          data: (action.data) ? action.data : state.medicoRatings.data,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.REQUEST_RATING:
    case types.RECEIVE_RATING:
      return {
        ...state,
        rating: {
          isLoading: action.isLoading,
          data: (action.data) ? action.data : state.medico.data,
          receivedAt: action.receivedAt,
        }
      }
    case types.REQUEST_SAVE_RATING:
    case types.RECEIVE_SAVE_RATING:
      return {
        ...state,
        saveRating: {
          isLoading: action.isLoading,
          error: action.error,
        }
      }
    case types.RESET_MEDICO:
      return {
        ...state,
        medico: INITIAL_STATE.medico
      }
    case types.REQUEST_PLANTAO:
    case types.RECEIVE_PLANTAO:
      return {
        ...state,
        plantao: {
          isLoading: action.isLoading,
          data: (action.data) ? action.data : state.plantao.data,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.REQUEST_PLANTAO_FILA:
    case types.RECEIVE_PLANTAO_FILA:
      return {
        ...state,
        plantaoFila: {
          isLoading: action.isLoading,
          data: (action.data) ? action.data : state.plantaoFila.data,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.REQUEST_PLANTAO_UNICO_PRICE:
    case types.RECEIVE_PLANTAO_UNICO_PRICE:
      return {
        ...state,
        plantaoUnicoPrice: {
          isLoading: action.isLoading,
          data: (action.data) ? action.data : state.plantaoUnicoPrice.data,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.REQUEST_SAVE_PLANTAO_UNICO:
    case types.RECEIVE_SAVE_PLANTAO_UNICO:
      return {
        ...state,
        savePlantaoUnico: {
          isLoading: action.isLoading,
          error: action.error,
        }
      }
    case types.REQUEST_ATENDIMENTO:
      return {
        ...state,
        atendimento: {
          isLoading: action.isLoading,
          data: action.silent ? state.atendimento.data : action.data,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.RECEIVE_ATENDIMENTO:
      return {
        ...state,
        atendimento: {
          isLoading: action.isLoading,
          data: action.data,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.REQUEST_CREATE_ATENDIMENTO:
    case types.RECEIVE_CREATE_ATENDIMENTO:
      return {
        ...state,
        createAtendimento: {
          isLoading: action.isLoading,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.RESET_CREATE_ATENDIMENTO:
      return {
        ...state,
        createAtendimento: INITIAL_STATE.createAtendimento
      }
    case types.REQUEST_JOIN_QUEUE:
    case types.RECEIVE_JOIN_QUEUE:
      return {
        ...state,
        joinQueue: {
          isLoading: action.isLoading,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.RESET_JOIN_QUEUE:
      return {
        ...state,
        joinQueue: INITIAL_STATE.joinQueue
      }
    case types.REQUEST_LEAVE_QUEUE:
    case types.RECEIVE_LEAVE_QUEUE:
      return {
        ...state,
        leaveQueue: {
          isLoading: action.isLoading,
          receivedAt: action.receivedAt,
          error: action.error,
        }
      }
    case types.RESET_LEAVE_QUEUE:
      return {
        ...state,
        leaveQueue: INITIAL_STATE.leaveQueue
      }
    case types.REQUEST_SCHEDULE_CANCEL:
    case types.RECEIVE_SCHEDULE_CANCEL:
      return {
        ...state,
        scheduleCancel: {
          isLoading: action.isLoading,
          error: action.error,
          success: action.success,
        }
      }
    case types.RESET_SCHEDULE_CANCEL:
      return {
        ...state,
        scheduleCancel: INITIAL_STATE.scheduleCancel
      }
      case types.REQUEST_RESCHEDULE:
      case types.RECEIVE_RESCHEDULE:
        return {
          ...state,
          reschedule: {
            isLoading: action.isLoading,
            error: action.error,
            success: action.success,
          }
        }
      case types.RESET_RESCHEDULE:
        return {
          ...state,
          reschedule: INITIAL_STATE.reschedule
        }
      case types.REQUEST_SCHEDULE_RETURN:
      case types.RECEIVE_SCHEDULE_RETURN:
        return {
          ...state,
          scheduleReturn: {
            isLoading: action.isLoading,
            error: action.error,
            success: action.success,
          }
        }
      case types.RESET_SCHEDULE_RETURN:
        return {
          ...state,
          scheduleReturn: INITIAL_STATE.scheduleReturn
        }
      case types.REQUEST_MEDICAL_RECORDS:
      case types.RECEIVE_MEDICAL_RECORDS:
        return {
          ...state,
          medialRecords: {
            isLoading: action.isLoading,
            data: action.data,
            receivedAt: action.receivedAt,
            error: action.error,
          }
        }
      case types.RESET_MEDICAL_RECORDS:
        return {
          ...state,
          medialRecords: INITIAL_STATE.medialRecords
        }
      case types.REQUEST_INVOICE_REQUEST:
      case types.RECEIVE_INVOICE_REQUEST:
        return {
          ...state,
          invoiceRequest: {
            isLoading: action.isLoading,
          }
        }
      case types.REQUEST_CONFIRM_PRESENCE:
      case types.RECEIVE_CONFIRM_PRESENCE:
        return {
          ...state,
          confirmPresence: {
            isLoading: action.isLoading,
          }
        }
      case types.REQUEST_ALL_CABINS:
      case types.RECEIVE_ALL_CABINS:
        return {
          ...state,
          cabins: {
            isLoading: action.isLoading,
            data: (action.data) ? action.data : state.cabins.data,
            receivedAt: action.receivedAt,
            error: action.error,
          }
        }
      case types.REQUEST_CABIN:
      case types.RECEIVE_CABIN:
        return {
          ...state,
          cabin: {
            isLoading: action.isLoading,
            data: (action.data) ? action.data : state.cabin.data,
            receivedAt: action.receivedAt,
            error: action.error,
          }
        }
    default:
      return state
  }
}
